import "./bootstrap";
// Supports weights 300-800
// import "@fontsource-variable/open-sans";

// try {
//     // window.Popper = require('popper.js').default;
//     // window.$ = window.jQuery = require('jquery');
//     // require('bootstrap/dist/js/bootstrap.bundle');
//     // require('popper.js/dist/popper.min.js');
//     // require('bootstrap/js/dist/alert.js');
//     require('bootstrap/js/dist/button.js');
//     require('bootstrap/js/dist/collapse.js');
//     // require('bootstrap/js/dist/dropdown.js');
//     // require('bootstrap/js/dist/modal.js');
//     // require('bootstrap/js/dist/tab.js');
//     require('bootstrap/js/dist/toast.js');
//     // require('bootstrap/js/dist/tooltip.js');
//     // require('bootstrap/js/dist/util.js');
//     // require('lazyload/lazyload');

//     // require('bootstrap');
// } catch (e) {}
